module.exports = __webpack_public_path__ + "static/media/banner-uslugi-krakow.d10bbb00.jpg";